import { createContext } from 'react';

export type PayoutSurface = 'table' | 'grid';
export type PayoutObservation = { hand: string; surface: PayoutSurface };
export type PayoutView = { view: 'lobby' | PayoutSurface; table: string };

export function reconcilePayoutObservations(
  observations: Map<string, PayoutObservation>,
  previous: PayoutView,
  current: PayoutView
): void {
  if (current.view === 'lobby' || previous.view === 'lobby') {
    observations.clear();
  } else if (
    current.view === 'table' &&
    (previous.view !== 'table' || previous.table !== current.table)
  ) {
    observations.forEach((_, id) => {
      if (id !== current.table) observations.delete(id);
    });
    if (previous.view === 'table' && previous.table !== current.table)
      observations.delete(current.table);
  }
}

// Scoped to SlideContainer: no hand memory survives leaving the table views.
export const PayoutObservationContext = createContext<{
  observations: Map<string, PayoutObservation>;
  surface: PayoutSurface;
  active: boolean;
} | null>(null);
